import { render, staticRenderFns } from "./PreferredHotelForm.vue?vue&type=template&id=0f8e9980"
import script from "./PreferredHotelForm.vue?vue&type=script&lang=js"
export * from "./PreferredHotelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports